import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { filterObj } from '@/utils/util';
import { getAction } from '@/api/manage';
export default {
  name: 'SelectAssetChemicalModal',
  data: function data() {
    return {
      siteList: [],
      title: '选择化学药品',
      queryParam: {},
      columns: [{
        title: '产品编号',
        align: 'center',
        dataIndex: 'assetCode'
      }, {
        title: '产品名称',
        align: 'center',
        dataIndex: 'productName'
      }, {
        title: '标准值',
        align: 'center',
        dataIndex: 'standard'
      }, {
        title: '标准值单位',
        align: 'center',
        dataIndex: 'refUnit_dictText'
      }, {
        title: '证书编号',
        align: 'center',
        dataIndex: 'certificateNo' // fixed: 'left',
        // width: 200,

      }, {
        title: '规格型号',
        align: 'center',
        dataIndex: 'model'
      }, {
        title: '剩余量(ml)',
        align: 'center',
        dataIndex: 'surplus'
      }, {
        title: '供应商',
        align: 'center',
        dataIndex: 'companyName'
      }, {
        title: '产品状态',
        align: 'center',
        dataIndex: 'status_dictText'
      }],
      dataSource: [],
      companyList: [],
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['5', '10', '20'],
        showTotal: function showTotal(total, range) {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      isorter: {
        column: 'create_time',
        order: 'desc'
      },
      selectedRowKeys: [],
      selectionRows: [],
      visible: false,
      toggleSearchStatus: false,
      category: '',
      url: {
        queryCompany: '/ea/company/info/queryCompanyName'
      }
    };
  },
  props: ['title'],
  created: function created() {
    this.getSite();
  },
  methods: {
    getSite: function getSite() {
      var _this = this;

      var params = {
        size: -1,
        status: 1
      };
      getAction('/site/info', params).then(function (res) {
        if (res.success) {
          _this.siteList = res.result.records;
        }
      });
    },
    add: function add(selectUser, userIds) {
      this.visible = true;
      this.edit(selectUser, userIds);
    },
    edit: function edit(selectUser, userIds) {
      this.loadCompany();
      this.loadData();

      if (!userIds) {
        this.selectedRowKeys = [];
      } else {
        this.selectedRowKeys[0] = userIds;
      }

      if (!selectUser) {
        this.selectionRows = [];
      } else {
        this.selectionRows = selectUser;
      }
    },
    loadCompany: function loadCompany() {
      var that = this;
      that.companyList = [];
      getAction(this.url.queryCompany).then(function (res) {
        if (res.success) {
          that.companyList = res.result;
        }
      });
    },
    loadData: function loadData(arg) {
      var _this2 = this;

      if (arg === 1) {
        this.ipagination.current = 1;
      }

      var params = this.getQueryParams(); //查询条件

      getAction('/ea/asset/chemical?status=1&category=' + this.category, params).then(function (res) {
        if (res.success) {
          _this2.dataSource = res.result.records;
          _this2.ipagination.total = res.result.total;
        }
      });
    },
    getQueryParams: function getQueryParams() {
      var param = Object.assign({}, this.queryParam, this.isorter);
      param.field = this.getQueryField();
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      return filterObj(param);
    },
    getQueryField: function getQueryField() {
      var str = 'id,';

      for (var a = 0; a < this.columns.length; a++) {
        str += ',' + this.columns[a].dataIndex;
      }

      return str;
    },
    onSelectChange: function onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
    },
    searchReset: function searchReset() {
      var that = this;
      Object.keys(that.queryParam).forEach(function (key) {
        that.queryParam[key] = '';
      });
      that.loadData(1);
    },
    handleTableChange: function handleTableChange(pagination, filters, sorter) {
      //TODO 筛选
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc';
      }

      this.ipagination = pagination;
      this.loadData();
    },
    handleCancel: function handleCancel() {
      this.selectionRows = [];
      this.selectedRowKeys = [];
      this.visible = false;
    },
    handleOk: function handleOk() {
      if (this.selectionRows.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      }

      this.$emit('selectProduct', this.selectionRows);
      this.handleCancel();
    },
    close: function close() {
      this.selectionRows = [];
      this.selectedRowKeys = [];
      this.visible = false;
    },
    searchByquery: function searchByquery() {
      this.loadData(1);
    },
    handleToggleSearch: function handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus;
    }
  }
};